import { LandingPageTypeDto } from '@/api/generated/models/landing-page-type-dto';
import { RouteEnum } from '@/layouts/routes/Route.model';

export const landingPageTypeToRoute: Record<LandingPageTypeDto, RouteEnum> = {
  [LandingPageTypeDto.MyProfile]: RouteEnum.USER_PROFILE,
  [LandingPageTypeDto.ProfileSearch]: RouteEnum.PROFILE_SEARCH,
  [LandingPageTypeDto.RequestTracker]: RouteEnum.RECRUITMENT_BOARD,
};

export const routeToLandingPageType: Partial<Record<RouteEnum, LandingPageTypeDto>> = {
  [RouteEnum.PROFILE_SEARCH]: LandingPageTypeDto.ProfileSearch,
  [RouteEnum.RECRUITMENT_BOARD]: LandingPageTypeDto.RequestTracker,
  [RouteEnum.USER_PROFILE]: LandingPageTypeDto.MyProfile,
};
